import { useEffect, useState } from 'react';
import { useSearchParams } from "react-router-dom";
import MgpMessage from '../elements/MgpMessage/MgpMessage';
import { extractJwtToken, hasValidateJwt } from "../utils/utils";
import { PROPOSITION_DOC_TYPES } from '../const/AppConst';
import UploadPropositionDocBloc from '../blocs/upload/UploadPropositionDocBloc';

export default function UploadMobileDocPage() {

  
  const [errorMsg, setErrorMsg] = useState<string | null>();

  const [searchParams] = useSearchParams();
  const propositionId = searchParams.get("propositionId");
  const jwtParams = searchParams.get("token");
  const docCode = searchParams.get("docCode");
  const eventId = searchParams.get("eventId");
  const docId = searchParams.get("docId");


  let docType = docCode ? PROPOSITION_DOC_TYPES.find(d => d.code === docCode) : null;
  useEffect(() => {
    if (!propositionId || !jwtParams || !docType || !eventId) {
      setErrorMsg("Le lien n'est pas valid");
    }
    const extractedJwt = extractJwtToken(jwtParams);
    if (!extractedJwt) {
      setErrorMsg("Le token n'est pas valide. Veuillez contacter le support MGP");
    }
  
    if (!hasValidateJwt(extractedJwt!)) {
      setErrorMsg("Le token n'est plus valide. Veuillez contacter le support MGP");
    }
  }, [errorMsg, docType, eventId, jwtParams, propositionId]);
  
 

  return (
    <>
      {!errorMsg && <div className="entreprise-container">
        <h1 className="title mb-sm">MGP - Parcours d'affiliation</h1>
        <div className="flex-grid bg-blanc shadow-noir p-lg m-xl-desktop">
            <UploadPropositionDocBloc token={jwtParams!} docType={docType!} eventId={eventId!} propositionId={propositionId!} docId={docId!}/>
        </div>
      </div>}
      <div>
        {errorMsg && <MgpMessage type="danger" message={errorMsg} hasCloseBtn={true}/>}
      </div>
    </>
  )
}
